AddMake = App.loadClass "grower::handlers/machinery/DialogAddMake_Handler"
AddModel = App.loadClass "grower::handlers/machinery/DialogAddMod_Handler"


exports.Fertilizer = (parent, data = {}) ->
    self = this

    @addMake = () ->
        dlg = parent.getHandler().createSubHandler AddMake, 'addMachDialog'
        if dlg
            dlg.subtypeId = self.selected_subtype().id
            dlg.saveUrl = 'backend/grower/machinery/add-machinery-make'
            dlg.isforcontroll = false
            dlg.successAction = (response) ->
                response.data.models = []
                self._addThing(response.data,
                    self.machinery_makes,
                    self.selected_make)
                self.addModel()
                parent.getHandler().validator.revalidateInput("[name='selected_make']")

            dlg.init()

    @addModel = () ->
        dlg = parent.getHandler().createSubHandler AddModel, 'addMachDialog'
        if dlg
            dlg.saveUrl = 'backend/grower/machinery/add-machinery-model'
            dlg.isforcontroll = false
            dlg.makeId = self.selected_make().id
            dlg.successAction = (response) ->
                self._addThing(response.data,
                    self.selected_make().models,
                    self.selected_model)
                parent.getHandler().validator.revalidateInput("[name='selected_model']")

            dlg.init()

    @addControllerMake = () ->
        dlg = parent.getHandler().createSubHandler AddMake, 'addMachDialog'
        if dlg
            dlg.saveUrl = 'backend/grower/machinery/add-controller-make'
            dlg.isforcontroll = true
            dlg.successAction = (response) ->
                response.data.models = []
                self._addThing(response.data,
                    self.controller_makes,
                    self.selected_controller_make)
                self.addControllerModel()
                parent.getHandler().validator.revalidateInput("[name='selected_controller_make']")

            dlg.init()

    @addControllerModel = () ->
        dlg = parent.getHandler().createSubHandler AddModel, 'addMachDialog'
        if dlg
            dlg.saveUrl = 'backend/grower/machinery/add-controller-model'
            dlg.isforcontroll = true
            dlg.makeId = self.selected_controller_make().id
            dlg.successAction = (response) ->
                self._addThing(response.data,
                    self.selected_controller_make().models,
                    self.selected_controller_model)
                parent.getHandler().validator.revalidateInput("[name='selected_controller_model']")

            dlg.init()

    # generic helper function used for each of the add* functions above
    @addThing = (newThing, things, selectedThing) ->
        things.push newThing
        things.sort self._comp
        selectedThing newThing

    @comp = (a, b) ->
        return strnatcasecmp(a.name, b.name)


    # Machinery subtypes, makes, and models
    # console.log data

    # todo: Get rid of the subscriptions for subtypes, makes, and models, and
    # for controller makes and models. Instead of subscriptions, we should be
    # using computed values to determine the contents of the related arrays.

    # get the saved subtype, make and model
    if data.machinery?.model?
        subtype_id = parseInt data.machinery?.model.make.subtype.id
        subtype = TAFFY(data.subtypes)(id: subtype_id).first()
        if subtype?
            make_id = parseInt data.machinery?.model.make.id
            make = TAFFY(subtype.makes)(id: make_id).first()
            if make?
                model_id = parseInt data.machinery?.model.id
                model = TAFFY(make.models)(id: model_id).first()

    @selected_subtype = ko.observable subtype ? null
    @selected_make = ko.observable make ? null
    @selected_model = ko.observable model ? null


    # get the nested arrays of subtypes, makes and models
    @machinery_subtypes = data.subtypes.sort self._comp
    @selected_subtype.subscribe (newval) ->
        if newval? and newval.makes?
            self.machinery_makes newval.makes.sort self._comp
        else
            self.machinery_makes []

    @machinery_makes = ko.observableArray @selected_subtype()?.makes.sort self._comp ? []
    @selected_make.subscribe (newval) ->
        if newval? and newval.models?
            self.machinery_models newval.models.sort self._comp
        else
            self.machinery_models []

    @machinery_models = ko.observableArray @selected_make()?.models.sort self._comp ? []


    # Controller makes / models

    # get the saved controller make and model
    if data.machinery?.controller_model?
        make_id = parseInt data.machinery?.controller_model.make.id
        comake = TAFFY(data.controller_makes)(id: make_id).first()
        if comake?
            model_id = parseInt data.machinery?.controller_model.id
            comodel = TAFFY(comake.models)(id: model_id).first()

    @selected_controller_make = ko.observable comake ? null
    @selected_controller_model = ko.observable comodel ? null

    # get the nested arrays of controller makes and models
    @controller_makes   = $.map(data.controller_makes, (value, index) -> return [value] ).sort self._comp
    @selected_controller_make.subscribe (newval) ->
        if newval? and newval.models?
            self.controller_models newval.models.sort self._comp
        else
            self.controller_models []

    @controller_models = ko.observableArray @selected_controller_make()?.models?.sort self._comp ? []


    @id                 = data.machinery?.id ? null
    @nickname           = ko.observable data.machinery?.name ? null
    @type               = ko.observable data.machinery?.model.make.subtype.name ? null
    @swath_width        = ko.observable data.machinery?.swath_width ? null
    @variable_rate      = ko.observable data.machinery?.variable_rate ? false

    @variable_rate.subscribe (val) ->
        if not val
            self.selected_controller_make null
            self.selected_controller_model null

    @canChangeDisplayMake   = ko.computed () ->
        if self.variable_rate() and parent.editing()
            return true
        else
            return false

    @canChangeDisplayModel   = ko.computed () ->
        if self.variable_rate() and parent.editing() and self.selected_controller_make()
            return true
        else
            return false

    @canChangeMake = ko.computed () ->
        if self.selected_subtype() and parent.editing()
            return true
        else
            return false

    @canChangeModel = ko.computed () ->
        if self.selected_make() and parent.editing()
            return true
        else
            return false


    return this

